import React from 'react';
import Chart from 'react-apexcharts';
import {
  Box,
  Card,
  CardContent,
  Typography,
  useTheme
} from '@material-ui/core';

function MemoryUtilization({ classes, data }) {
  const theme = useTheme();

  if (!data || Object.keys(data).length === 0) {
    return null;
  }

  const chartData = {
    options: {
      chart: {
        background: theme.palette.background.paper,
        sparkline: {
          enabled: true
        }
      },
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          hollow: {
            size: '50%'
          },
          track: {
            background: '#e2e2e2',
            strokeWidth: '90%',
            margin: 5
          },
          dataLabels: {
            name: {
              offsetY: 28,
              fontFamily: theme.typography.fontFamily,
              fontSize: 16,
              color: '#111'
            },
            value: {
              offsetY: -20,
              fontSize: 22,
              color: '#111'
            }
          }
        }
      },
      title: {
        text: 'Memory Utilization'
      },
      labels: [' ']
    },
    series: [data['heap.percentUsed']]
  };

  return (
    <Card>
      <Box
        maxWidth={320}
        mx="auto"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <CardContent>
          <Chart
            options={chartData.options}
            series={chartData.series}
            type="radialBar"
            className={classes.chart}
          />
          <Typography
            align="left"
            color="textSecondary"
            variant="body1"
            component="p"
          >
            Heap Initial: {Math.floor(data['heap.initial'] / (1024 * 1024))}m
          </Typography>
          <Typography
            align="left"
            color="textSecondary"
            variant="body1"
            component="p"
          >
            Heap Maximum: {Math.floor(data['heap.maximum'] / (1024 * 1024))}m
          </Typography>
          <Typography
            align="left"
            color="textSecondary"
            variant="body1"
            component="p"
          >
            Heap Used: {Math.floor(data['heap.used'] / (1024 * 1024))}m
          </Typography>
          <Typography
            align="left"
            color="textSecondary"
            variant="body1"
            component="p"
          >
            Heap Free: {Math.floor(data['heap.free'] / (1024 * 1024))}m
          </Typography>
        </CardContent>
      </Box>
    </Card>
  );
}

export default MemoryUtilization;
